import $ from 'jquery'
import ManageSectionFrom from '@/views/consultations/en-cours/consultation-sections/manage-section-form'
import ParamCertificat from '@/views/consultations/en-cours/certificats-medicaux/param-certificat'
import ManageCertificatForm from '@/views/consultations/en-cours/certificats-medicaux/manage-certificat-form'
import store_fiche from "@/store/mods/consultations/fiche-consultations"

export default {
    name: 'certificats-medicaux',
    components: {
        ManageSectionFrom, ParamCertificat,
        ManageCertificatForm
    },
    props: {
        consultation: Object,
        section_name: String,
        slug: String,
        fcs_id: {
            type: Number,
            default: () => (0)
        },
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object,
        patient: Object
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            info_patient: {},
            info_user: {},
            grs_toggler: 0,
            group_id: 0,
            list_contents: [],
            selected_content: {},
            data_to_be_deleted: {},

            liste_champs: [],
            liste_champ_empty: false,
            liste_champ_loading: true,

            prev_info: {
                file_name: '',
                label: ''
            },
            prev_toggler: 0,
            c_slug: "",
            one_is_active: false,
            selected_certif: {},
            active_champs: [],
            form_toggler: 0,
            is_edit: 1,
            existing_certificats: [],
            edit_set_loading: false,

            del_toggler: 0
        }
    },

    watch: {
        evolution_toggler() {
            this.getData()

            this.userInfoSetter()
            this.getListeChamps()
        }
    },

    computed: {
        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        },
    },

    mounted() {
        
    },

    methods: {
        getListeChamps() {
            this.liste_champ_loading = true
            const data = {
                fcs_id: this.fcs_id,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id
            }
            store_fiche.geListeChampByFicheSection(data).then((response) => {
                this.liste_champs = response
                if (this.liste_champs.length == 0) {
                    this.liste_champ_empty = true
                } else {
                    this.liste_champ_empty = false

                    this.liste_champs.forEach(chmp => {
                        if (chmp.is_active == 1) {
                            this.one_is_active = true
                        }
                    });
                }
                this.liste_champ_loading = false
            })
        },

        userInfoSetter() {
            this.info_patient = {
                nom_patient: this.patient.nom+' '+this.patient.prenoms,
                sexe: (this.patient.sexe_id == 1)?'H':(this.patient.sexe_id == 2)?'F':'',
                telephone: this.patient.telephone_mobile,
                num_dossier: this.patient.code,
                age: this.patient.age,
                date_naissance: this.formatDateToDmY(this.patient.date_naissance)
            }

            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        editCertif(data, field) {
            this.edit_set_loading = true
            this.form_toggler = (this.form_toggler == 0)?1:0
            this.active_champs = this.liste_champs.filter(item => item.champ === field.field_name)

            this.group_id = data.group_service_id
            this.selected_content = field
            this.is_edit = 1
            
            const timestamp = new Date().getTime();
            this.c_slug = this.slug+timestamp
            
            setTimeout(() => {
                this.edit_set_loading = false
                $('.certif-form-'+this.evolution_id+'-'+this.c_slug).modal('show')  
            }, 600);
            
        },

        getData() {
            this.is_loading = true
            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                data_type: this.slug,
                est_en_cours: true
            }

            store_fiche.getCustomSectionContent(data).then((response) => {
                this.existing_certificats = []
                this.list_contents = response
                
                if (response.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false

                    for(let i = 0; i < this.list_contents.length; i++) {
                        for(let j = 0; j < this.list_contents[i].fields.length; j++) {
                            let content = this.list_contents[i].fields[j].value
                            content = content.replace("[NOM_MEDECIN]", this.list_contents[i].user)
                            content = content.replace("[NOM_PATIENT]", this.info_patient.nom_patient)
                            content = content.replace("[DATE_NAISSANCE_PATIENT]", this.formatDateToDmY(this.patient.date_naissance))
                            content = content.replace("[VILLE]", this.ville_le)
                            content = content.replace("[DATE]", this.formatDateToDmY(this.list_contents[i].date))
                            content = content.replace("[NOM_CLINIQUE]", this.nom_clinique)
                            content = content.replace("[AGE_CLINIQUE]", this.patient.age)

                            this.list_contents[i].fields[j].value = content

                            this.existing_certificats.push(this.list_contents[i].fields[j].field_name)
                        }
                    }
                }
                
                this.is_loading = false
            })
        },

        setVisibleField() {
            this.is_edit = 0
            this.grs_toggler = (this.grs_toggler == 0)?1:0
            $('#param-'+this.evolution_id+'-'+this.slug).modal('show')
        },

        preview(field) {
            const timestamp = new Date().getTime();
            this.c_slug = this.slug+timestamp

            // const mdl_ref = 'prev_certif'+this.evolution_id+this.c_slug
            this.selected_certif = field
            this.$refs['prev_certif'].show()
        },

        printCertificat(group_certif, field) {
            const data = {
                date: group_certif.date,
                group_service_id: group_certif.group_service_id,
                reference: group_certif.reference,
                user: group_certif.user,
                certif: field
            }

            this.$store.commit("SET_CAN_PRINT_CERTIF", true)
            this.$store.commit("SET_CERTIF_TO_PRINT", data)
        },

        removeSection(data, field) {
            this.del_toggler = (this.del_toggler == 0)?1:0
            this.data_to_be_deleted = {
                libelle: field.field_name,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: data.group_service_id,
                data_type: this.slug
            }
            
            const timestamp = new Date().getTime();
            this.c_slug = this.slug+timestamp+data.group_service_id
            $('.certif-del-'+this.evolution_id+'-'+this.c_slug).modal('show')
        },
    }
}